<template>
  <div class="loginPage_wrapper">
    <header class="top_header">
      <img src="../../assets/images/dosti91.svg" />
      <h1>Dosti91</h1>
    </header>
    <div class="login_container">
      <div class="login_form">
        <div class="input-box">
          <label for="email">Name</label>
          <input
            type="text"
            name="email"
            placeholder="Enter Your Name"
            @input="handleChange($event)"
          />
          <label class="err_msg">{{ formErrors.email }}</label>
          <label for="Password">Password</label>
          <input
            type="password"
            name="Password"
            placeholder="Enter Your Password"
            @input="handleChange($event)"
          />
          <label class="err_msg">{{ formErrors.Password }}</label>
        </div>
        <div class="btn_block" @click="handlePartnerLogin">
          <!-- <router-link
            tag="button"
            class="login_btn"
          >
            LogIn
          </router-link> -->
          <a class="login_btn"> Login </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as CommonHelper from "../../utils/helper";
export default {
  name: "PartnerLogin",
  components: {},
  data() {
    return {
      loading: false,
      ShowTab: 1,
      email: "aap ki laila",
      Password: "1234",
      formErrors: {
        email: "",
        Password: ""
      }
    };
  },
  computed: {},
  methods: {
    handleChange(e) {
      const { name, value } = e.target;
      this.$data[name] = value;
    },
    handlePartnerLogin() {
      const { email, Password } = this.$data;
      // harry,1234
      this.$store
        .dispatch({
          type: "partnerLogin",
          payload: { user_name: email, password: Password }
        })
        .then(({ data }) => {
          console.log("===", data.data.operator_id);
          if (data.success) this.$router.push("/partner-calling-screen/"+ data.data.operator_id);
          this.$cookie.set('loginSuccess', 'true')
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    console.log("====", this.$socket);
    this.$socket.close();
    this.$socket.on("disconnect", () => {
      console.log("=run");
      console.log("***disconnected******", this.$socket.disconnected);
    });
  },
  created() {}
};
</script>

<style scoped>
/* ********************************loginPage***************************************8 */

.loginPage_wrapper {
  width: 100%;
  background: #3f032d;
}

.loginPage_wrapper .top_header {
  text-align: center;
  width: 100%;
  padding: 15px;
}

.loginPage_wrapper .top_header h1 {
  color: #ff5eb5;
}

.login_container {
  background: #56083f;
  border-radius: 20px 20px 0 0;
  height: calc(100vh - 110px);
  position: relative;
}

.login_container .login_form {
  position: absolute;
  text-align: left;
  line-height: 32px;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  width: 260px;
}

.input-box {
  width: 100%;
  height: auto;
  display: block;
}

.input-box label {
  font-weight: 500;
  color: #fff;
  font-size: 0.875em;
  width: 100%;
  display: block;
}

.input-box input {
  outline: none;
  border: none;
  line-height: normal;
  color: #000000;
  font-weight: 600;
  font-size: 0.875em;
  background: #fff;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  width: 100%;
}

.btn_block {
  width: 100%;
}

.btn_block .login_btn {
  background-color: #f252a9;
  color: white;
  padding: 15px;
  border: none;
  width: 100%;
  font-size: 0.875em;
  font-weight: 600;
  text-align: center;
  outline: none;
  margin-top: 20px;
  border-radius: 30px;
}
</style>
